// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"AU-z","inlineTitle":"BU-z","sponsoredAdsWrapper":"CU-z","marketplaceRecosWrapper":"DU-z"};